import { useCallback } from 'react';
import { useAlert } from './useAlert';
import { RuleWarning, formatRuleWarnings } from '../utils/ruleWarnings';

/** 操作成功但違反「提示」模式的球場規則時，用既有的警告訊息條告知 */
export function useRuleWarningAlert() {
    const { showWarning } = useAlert();

    return useCallback(
        (warnings: RuleWarning[] | undefined | null) => {
            const message = formatRuleWarnings(warnings);
            if (message) {
                showWarning(message);
            }
        },
        [showWarning]
    );
}
